import ClaimAndInjury from "./ClaimAndInjury.jsx";

export default ClaimAndInjury;
